module.exports = __webpack_public_path__ + "static/media/group.6d86e792.jpg";